import React, { Component } from 'react';
import Router from 'next/router';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Color from '~/utils/colors';
import { commaizeInt } from '~/utils/helpers';
// import activities from '~/activities.json';
import topActivities from '~/topActivities.json';

import { parseFilterToQuery } from '~/utils/search';

const optionsActivity = topActivities.map((act) => ({
  key: act,
  label: act
}));

const filters = (exchangeRates, currency) => {
  const changeCurrency = (num) => commaizeInt(Math.floor(num * (exchangeRates[currency] || 1)), currency);
  return [{
    key: 'activities',
    label: 'Activities',
    type: 'grouped-dropdown',
    options: optionsActivity,
  },
  {
    key: 'starting_time',
    label: 'Starting Time',
    type: 'dropdown',
    options: [{
      key: 'Morning',
      label: 'Morning',
    }, {
      key: 'Afternoon',
      label: 'Afternoon',
    }, {
      key: 'Evening',
      label: 'Evening'
    }, {
      key: 'Night',
      label: 'Night'
    }]
  },
  {
    key: 'price_range',
    label: 'Price Range',
    type: 'slider',
    options: [{
      key: '1 - 1000',
      label: `Under ${changeCurrency(1000)} ${currency}`,
      // label: 'Under 1,000 THB',
    }, {
      key: '1000 - 2000',
      label: `${changeCurrency(1000)} - ${changeCurrency(2000)} ${currency}`,
      // label: '1,000 - 2,000 THB',
    }, {
      key: '2000 - 3000',
      label: `${changeCurrency(2000)} - ${changeCurrency(3000)} ${currency}`,
      // label: '2,000 - 3,000 THB',
    }, {
      key: '3000 - 4000',
      label: `${changeCurrency(3000)} - ${changeCurrency(4000)} ${currency}`,
      // label: '3,000 - 4,000 THB',
    }, {
      key: '4000 - 5000',
      label: `${changeCurrency(4000)} - ${changeCurrency(5000)} ${currency}`,
      // label: '4,000 - 5,000 THB',
    }, {
      key: '5000 - 50000',
      label: `Over ${changeCurrency(5000)} ${currency}`,
      // label: 'Over 5,000 THB'
    }]
  },
  {
    key: 'change_type',
    label: 'Type',
    type: 'dropdown',
    options: [{
      key: 'all',
      label: 'All Trips'
    }, {
      key: 'famous-attractions',
      label: 'Famous Attractions'
    }, {
      key: 'local-experiences',
      label: 'Local Experiences'
    }]
  }];
};

const FilterItemContainer = styled.div`
  border-radius: 6px;
  position: relative;
  display: inline-block;
  background: transparent;
  outline: none;
  color: ${Color.gray};
  border: 1px solid ${Color.borderGray};
  padding: 10px;
  margin-right: 10px;
  cursor: pointer;
  margin-bottom: 10px;
  @media (min-height: 701px) {
    &:hover {
      background: ${Color.borderGray};
    }
  }
  .fa {
    margin-left: 10px;
  }
  @media (max-width: 700px) {
    font-size: 12px;
    padding: 8px;
    margin-right: 0;
  }
  ${props => props.active && `
    background: ${Color.borderGray};  
  `}
`;

const Select = styled.select`
  opacity: 0;
  z-index: 100;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border: 0;
  box-sizing: border-box;
  padding-left: 10px;
  height: 100%;
  width: 100%;
  cursor: pointer;
`;

const Option = styled.option`
  color: ${Color.gray};
`;

const DesktopFilterItem = (props) => {
  let label;
  if (props.label === 'Type' && props.type) {
    label = props.options.find((option) => option.key === props.type).label || props.label;
  } else {
    label = props.value ? props.options.find((option) => option.key === props.value).label : props.label;
  }
  return (
    <FilterItemContainer
      active={props.value && props.label !== 'Type'}
      onClick={props.onOpenFilter}
    >
      {label}
      <Select onChange={props.onSelect} value={props.value || ''}>
        {props.label !== 'Type' && <Option value="">{props.label}</Option>}
        {props.options.map((option) => (
          <Option key={option.key} value={option.key}>{option.label}</Option>
        ))}
      </Select>
      <i className="fa fa-caret-down" />
    </FilterItemContainer>
  );
};

DesktopFilterItem.propTypes = {
  // key: PropTypes.string,
  // active: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.array,
  // onClick: PropTypes.func,
  onOpenFilter: PropTypes.func,
  onSelect: PropTypes.func,
  type: PropTypes.string,
};

const ClearContainer = styled.span`
  position: relative;
  display: inline-block;
  font-weight: 500;
  @media (max-width: 700px) {
    display: block;
    text-align: right;
    margin-top: 5px;
  }
`;

const ClearFilters = styled.a`
  padding: 10px 0;
  @media (max-width: 700px) {
    font-size: 12px;
  }
`;
class DesktopFilter extends Component {
  static propTypes = {
    // search: PropTypes.func,
    clearFilter: PropTypes.func,
    updateFilter: PropTypes.func,
    logOpenFilter: PropTypes.func,
    query: PropTypes.object,
    filterData: PropTypes.object,
  };

  state = {}

  onClearFilters() {
    // Promise.resolve(this.props.clearFilter())
    // .then(() => {
    // this.setState(initialState);
    this.props.clearFilter();
    Router.push(
      {
        pathname: '/search',
        query: {
          city: this.props.query.city,
          type: this.props.query.type,
        },
      },
      `/to/${this.props.query.city}/${this.props.query.type}`
    );
    // });
  }

  onFilterChange(key, e) {
    // this.key = key;
    this.value = e.target.value;
    const { value } = e.target;
    const { filterData, query } = this.props;
    let f = {...filterData};
    if (key === 'price_range') {
      const match = value.match(/([0-9]+) - ([0-9]+)/);
      if (match) {
        f.price_from = match[1]; // eslint-disable-line
        f.price_to = match[2]; // eslint-disable-line
      } else {
        f.price_from = null;
        f.price_to = null;
      }
    } else if (key === 'change_type') {
      if (value === 'local-experts') {
        f = {};
      }
    } else {
      f[key] = value;
    }
    const type = key === 'change_type' ? value : query.type;
    const queryStr = parseFilterToQuery(f);
    this.props.updateFilter(f, key, value, true); // log
    Router.push(
      {
        pathname: '/search',
        query: {
          ...f,
          city: query.city,
          type,
        },
      },
      `/to/${query.city}/${type}${queryStr}`
    );
  }

  render() {
    const { props, state } = this;
    const { filterData } = props;
    return (
      <div>
        {props.filters.map((filter, index) => {
          if (!(props.query.city === 'Other' && filter.key === 'change_type') && !(props.query.type === 'local-experts' && filter.key !== 'change_type')) {
            let value = '';
            if (filter.key === 'price_range' && filterData.price_from && filterData.price_to) {
              value = `${filterData.price_from} - ${filterData.price_to}`;
            } else if (filter.key === 'change_type') {
              value = this.props.query.type;
            } else {
              value = filterData[filter.key];
            }
            return (
              <DesktopFilterItem
                // onSelect={(e) => this.onFilterChange(filter.label, e)}
                onSelect={(e) => this.onFilterChange(filter.key, e)}
                {...filter}
                {...state}
                type={this.props.query.type}
                onOpenFilter={() => this.props.logOpenFilter(filter.key)}
                key={`filter-${index}`}
                style={{ marginRight: index + 1 === props.filters.length ? '10px' : '0' }}
                // active={filter.key === 'price_range' ? (!!filterData.price_from || !!filterData.price_to) : !!filterData[filter.key]}
                value={value}
              />
            );
          }
          return <div key={`filter-${index}`} style={{ display: 'inline-block', marginRight: index + 1 === props.filters.length ? '10px' : '0' }}></div>;
        })}
        {Object.keys(filterData).some((key) => filterData[key]) && (
          <ClearContainer>
            <ClearFilters onClick={() => this.onClearFilters()}>Clear Filters</ClearFilters>
          </ClearContainer>
        )}
      </div>
    );
  }
}

const FilterTitle = styled.p`
  font-size: 20px;
  font-weight: 700;
  @media (max-width: 700px) {
    font-size: 15px;
  }
`;

const Filter = (props) => (
  <div>
    <FilterTitle>Filters</FilterTitle>
    <DesktopFilter
      filters={filters(props.exchangeRates, props.currency)}
      search={props.search}
      updateFilter={props.updateFilter}
      clearFilter={props.clearFilter}
      query={props.query}
      filterData={props.filterData}
      logOpenFilter={props.logOpenFilter}
    />
  </div>
);
Filter.propTypes = {
  search: PropTypes.func,
  logOpenFilter: PropTypes.func,
  exchangeRates: PropTypes.object,
  currency: PropTypes.string,
  updateFilter: PropTypes.func,
  clearFilter: PropTypes.func,
  query: PropTypes.object,
  filterData: PropTypes.object,
};

export default Filter;
